<template>
  <div class="row bgc-wrapper margin-top-42">
    <div class="col-12 traveller-heading">
      <div class="row">
        <button
          id = "prev_Pol_pcod_Details"
          type="button"
          class="expand-form-button"
          data-toggle="collapse"
          aria-label="Expand Journey Details"
          data-target="#previousPolicyDetailsForPcod"
        >
          <img alt="Toggle Customer Details" src="@/assets/images/arr-up.png" />
        </button>
        <div class="col-8 p-0">
          <h3 class="pre-policyPCOD">Previous Policy Details</h3>
        </div>
      </div>
    </div>
    <div class="collapse show col-12 bgc-form-box" id="previousPolicyDetailsForPcod">
      <!-- ODS Required starts-->
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
          <float-label
            label="ODS Required for?"
            :fixed="isFloat(previousPolicyDetailsForPcodData.odsRequiredFor.value)"
          >
            <select
              class="form-control"
              :class="{ 'bgc-error-field': previousPolicyDetailsForPcodData.odsRequiredFor.errorText!=='' }"
              v-evolvews="previousPolicyDetailsForPcodData.odsRequiredFor"
              v-model="previousPolicyDetailsForPcodData.odsRequiredFor.value"
            >
              <option disabled value>ODS Required for?</option>
              <option>TP only</option>
            </select>
          </float-label>
          <span
            class="error-text"
            v-if="previousPolicyDetailsForPcodData.odsRequiredFor.errorText!==''"
          >{{previousPolicyDetailsForPcodData.odsRequiredFor.errorText}}</span>
          </div>
        </div>
      </div>
      <!-- ODS Required for? end-->
      <!-- Active TP Policy Number starts-->
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
          <float-label
            :fixed="isFloat(previousPolicyDetailsForPcodData.activeTPPolicyNumber.value)"
          >
            <input
              type="text"
              class="form-control"
              maxlength="50"
              :class="{ 'bgc-error-field': previousPolicyDetailsForPcodData.activeTPPolicyNumber.errorText!=='' }"
              v-evolvews="previousPolicyDetailsForPcodData.activeTPPolicyNumber"
              v-model="previousPolicyDetailsForPcodData.activeTPPolicyNumber.value"
              placeholder="Active TP Policy Number*"
            />
          </float-label>
          <span
            class="error-text"
            v-if="previousPolicyDetailsForPcodData.activeTPPolicyNumber.errorText!==''"
          >{{previousPolicyDetailsForPcodData.activeTPPolicyNumber.errorText}}</span>
          </div>
        </div>
        <!-- Active TP Policy Number end-->
        <!-- Active TP Insurance from starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
          <float-label
            label="Active TP Insurance from*"
            :fixed="isFloat(previousPolicyDetailsForPcodData.activeTPInsuranceFrom.value)"
          >
            <select
              class="form-control"
              v-on:keydown="alphaNumeric"
              :class="{ 'bgc-error-field': previousPolicyDetailsForPcodData.activeTPInsuranceFrom.errorText!=='' }"
              v-evolvews="previousPolicyDetailsForPcodData.activeTPInsuranceFrom"
              v-model="previousPolicyDetailsForPcodData.activeTPInsuranceFrom.value"
            >
              <option disabled value>Active TP Insurance from*</option>
              <option>Select</option>
            </select>
          </float-label>
          <span
            class="error-text"
            v-if="previousPolicyDetailsForPcodData.activeTPInsuranceFrom.errorText!==''"
          >{{previousPolicyDetailsForPcodData.activeTPInsuranceFrom.errorText}}</span>
          </div>
        </div>
        <!-- Active TP Insurance from end-->
        <!-- TP Policy Start Date starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
          <float-label
            label="TP Policy Start Date*"
            :fixed="isFloat(previousPolicyDetailsForPcodData.tpPolicyStartDate.value)"
          >
            <datepicker
              format="dd/MM/yyyy"
              :typeable="true"
              v-model="previousPolicyDetailsForPcodData.tpPolicyStartDate.value"
              :input-class="isInputError(previousPolicyDetailsForPcodData.tpPolicyStartDate.errorText)"
              @datePickerBlurred="checkError(previousPolicyDetailsForPcodData.tpPolicyStartDate,false)"
              placeholder="TP Policy Start Date*"
            ></datepicker>
          </float-label>
          <span
            class="error-text"
            v-if="previousPolicyDetailsForPcodData.tpPolicyStartDate.errorText!==''"
          >{{previousPolicyDetailsForPcodData.tpPolicyStartDate.errorText}}</span>
          </div>
        </div>
        <!-- TP Policy Start Date end-->
        <!-- TP Policy End Date starts-->
        <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
          <float-label
            label="TP Policy End Date*"
            :fixed="isFloat(previousPolicyDetailsForPcodData.tpPolicyEndDate.value)"
          >
            <datepicker
              format="dd/MM/yyyy"
              :typeable="true"
              v-model="previousPolicyDetailsForPcodData.tpPolicyEndDate.value"
              :input-class="isInputError(previousPolicyDetailsForPcodData.tpPolicyEndDate.errorText)"
              @datePickerBlurred="checkError(previousPolicyDetailsForPcodData.tpPolicyEndDate,false)"
              placeholder="TP Policy End Date*"
            ></datepicker>
          </float-label>
          <span
            class="error-text"
            v-if="previousPolicyDetailsForPcodData.tpPolicyEndDate.errorText!==''"
          >{{previousPolicyDetailsForPcodData.tpPolicyEndDate.errorText}}</span>
          </div>
        </div>
        <!-- TP Policy End Date* end-->
      </div>
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
import { reactive } from '@vue/composition-api';
export default {
  name: "PreviousPolicyDetailsForPcod",
  props: ["previousPolicyDetailsForPcodData"],
  components: {
    FloatLabel,
    Datepicker
  },
  setup(props){
    let state = reactive({
    });
    //methods
    const checkError= functions.checkError;
    const isFloat= functions.isFloat;
    const alphaNumeric= functions.alphaNumeric;
    const isInputError= functions.isInputError;
    //return
    return{
      checkError,
      isFloat,
      alphaNumeric,
      isInputError
    }
  },
  directives: {
    evolvews: functions.evolvews,
  }
};
</script>
<style scoped>
</style>